import React from 'react';
import { YILU_OVERRIDE_KEY } from '@yiluhub/travel-integration';

import Logo from './Logo';

export const overrides = {
  [YILU_OVERRIDE_KEY.YILU_HEADER_LOGO]: () => <Logo />,
};
